var _themes;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import styled from 'styled-components';
import { mix, transparentize } from 'polished';
import tscStyles from '../constants/TscStyles';
import TscThemeName from '../constants/TscThemeName';
import { getClassName } from '../utils/get-class-name';
var eightyFivePercentColorModifier = 0.85;
var ninetyPercentColorModifier = 0.90;
var themes = (_themes = {}, _defineProperty(_themes, TscThemeName.dawn, {
  dropdownControl: {
    color: tscStyles.color.text.mediumDark,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.action.secondaryDawn, tscStyles.color.modifier.dark),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.action.secondaryDawn, tscStyles.color.modifier.dark)
  },
  Option: {
    hoverColor: transparentize(ninetyPercentColorModifier, tscStyles.color.modifier.dark)
  }
}), _defineProperty(_themes, TscThemeName.dusk, {
  dropdownControl: {
    color: tscStyles.color.text.light,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.action.secondaryDusk, tscStyles.color.modifier.light),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.action.secondaryDusk, tscStyles.color.modifier.light)
  },
  Option: {
    hoverColor: transparentize(ninetyPercentColorModifier, tscStyles.color.modifier.dark)
  }
}), _themes);
var DropdownControlWrapper = styled.div.withConfig({
  displayName: "NavigationDropdown__DropdownControlWrapper"
})(["position:relative;"]);
var DropdownControl = styled.div.withConfig({
  displayName: "NavigationDropdown__DropdownControl"
})(["cursor:pointer;color:", ";display:block;height:", ";line-height:", ";padding:0 1.5rem 0 1rem;position:relative;text-align:center;user-select:none;z-index:2;transition:background-color 125ms linear;", " &:after{border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid ", ";bottom:0;content:'';height:0;position:absolute;right:.5rem;top:45%;width:0;}&:hover{background-color:", ";}&:active{background-color:", ";}span{pointer-events:none;}"], function (props) {
  return themes[props.themeName].dropdownControl.color;
}, function (props) {
  return props.height;
}, function (props) {
  return props.height;
}, function (props) {
  return props.isActive ? "\n      background-color: ".concat(themes[props.themeName].dropdownControl.activeColor, ";\n   ") : '';
}, function (props) {
  return themes[props.themeName].dropdownControl.color;
}, function (props) {
  return themes[props.themeName].dropdownControl.hoverColor;
}, function (props) {
  return themes[props.themeName].dropdownControl.activeColor;
});
var SubMenu = styled.div.withConfig({
  displayName: "NavigationDropdown__SubMenu"
})(["background-color:", ";border:1px solid ", ";box-shadow:4px 4px 4px rgba(0,0,0,.1);cursor:pointer;display:block;max-height:0rem;overflow:hidden;padding:.25rem 0 .5rem 0;position:absolute;visibility:hidden;transition:all 125ms linear;top:", ";z-index:2;hr{border:1px solid ", ";}&.tsc-display-submenu{transition:all 400ms linear;max-height:30rem;visibility:visible;}&:hover ~ .tsc-dropdown-control{background-color:", ";}"], tscStyles.color.global.white, tscStyles.color.global.boxShadow, function (props) {
  return props.dropdownControlHeight;
}, tscStyles.color.global.boxShadow, function (props) {
  return themes[props.themeName].dropdownControl.hoverColor;
});
var Option = styled.div.withConfig({
  displayName: "NavigationDropdown__Option"
})(["line-height:1.25rem;padding:.25rem 1rem;user-select:none;white-space:nowrap;&:hover{background-color:", ";}span{pointer-events:none;}"], function (props) {
  return themes[props.themeName].Option.hoverColor;
});

var NavigationDropdown = function NavigationDropdown(_ref) {
  var className = _ref.className,
      _ref$dropdownLabel = _ref.dropdownLabel,
      dropdownLabel = _ref$dropdownLabel === void 0 ? '' : _ref$dropdownLabel,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '3.5rem' : _ref$height,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$themeName = _ref.themeName,
      themeName = _ref$themeName === void 0 ? TscThemeName.dusk : _ref$themeName;

  var _React$useState = React.useState({
    submenuVisible: false
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var _renderOption = function _renderOption(option) {
    return _jsx(Option, {
      className: getClassName(className, 'option'),
      onMouseDown: function onMouseDown(e) {
        return option.onSelectCallback ? option.onSelectCallback(e) : undefined;
      },
      themeName: themeName,
      children: _jsx("span", {
        children: option.label
      })
    }, "".concat(option.id));
  };

  var _renderOptions = function _renderOptions(optionsData) {
    var renderedOptions = [];
    optionsData.forEach(function (option, i) {
      if (Array.isArray(option)) {
        renderedOptions = renderedOptions.concat(_renderOptions(option));

        if (i !== optionsData.length - 1) {
          renderedOptions.push(_jsx("hr", {}, "".concat(i, "_hr")));
        }
      } else {
        renderedOptions.push(_renderOption(option));
      }
    });
    return renderedOptions;
  };

  var _toggleSubmenu = function _toggleSubmenu(e) {
    e.stopPropagation();
    setState({
      submenuVisible: !state.submenuVisible
    });
  };

  var _displaySubmenu = function _displaySubmenu(e) {
    e.stopPropagation();

    if (!state.submenuVisible) {
      setState({
        submenuVisible: true
      });
    }
  };

  var _hideSubmenu = function _hideSubmenu(e) {
    e.stopPropagation();

    if (state.submenuVisible) {
      setState({
        submenuVisible: false
      });
    }
  };

  var _renderDropdownControl = function _renderDropdownControl(dropdownControlLabel, controlHeight, controlIsActive) {
    return _jsx(DropdownControl, {
      className: getClassName(className, 'dropdown-control', 'tsc-dropdown-control'),
      onClick: _toggleSubmenu,
      onMouseOver: _displaySubmenu,
      onMouseLeave: _hideSubmenu,
      isActive: controlIsActive,
      height: controlHeight,
      themeName: themeName,
      children: _jsx("span", {
        children: dropdownControlLabel
      })
    });
  };

  var _renderSubMenu = function _renderSubMenu(subMenuOptions, submenuVisible, dropdownControlHeight) {
    var defaultClass = submenuVisible ? 'tsc-display-submenu' : '';
    return _jsx(SubMenu, {
      className: getClassName(className, 'sub-menu', defaultClass),
      dropdownControlHeight: dropdownControlHeight,
      onClick: _hideSubmenu,
      onMouseOver: _displaySubmenu,
      onMouseLeave: _hideSubmenu,
      themeName: themeName,
      children: _renderOptions(subMenuOptions)
    });
  };

  return _jsxs(DropdownControlWrapper, {
    className: getClassName(className, null, 'dropdown-control-wrapper'),
    children: [_renderSubMenu(options, state.submenuVisible, height), _renderDropdownControl(dropdownLabel, height, isActive)]
  });
};

var NavigationDropdownTest = {
  DropdownControlWrapper: DropdownControlWrapper
};
export { NavigationDropdown, NavigationDropdownTest };
export default NavigationDropdown;